module.exports = __webpack_public_path__ + "img/btn_my_collect_off.dbf8e007.png";